export const periodZh = {
  "cost.fee_short": "费用",
  "cost.resource_short": "资源",
  "cost.unit_price_short": "单价",
  "cost.billable_short": "计费用量",
  "cost.reported_short": "官方日费用",
  "cost.cumulative_short": "官方累计费用",
  "cost.source_short": "来源",
  "cost.invoice_level_short": "账单级项目",

  "cost.full_invoice_toggle": "显示完整账单",
  "cost.invoice_number": "账单号",
  "cost.charge_kind": "类型",
  "cost.invoice_item": "项目",
  "cost.no_invoice_short": "本月暂无账单",
  "cost.last_sync": "最后同步",
  "cost.auto_sync_help":
    "后台每小时自动同步，页面打开时每 15 分钟刷新。时间为 UTC；供应商入账可能延迟。",
  "cost.sync_failed_short": "同步异常",
  "cost.fixed_short": "固定费用",
  "cost.plan_short": "套餐",
  "cost.monthly_short": "月费",
  "cost.daily_short": "每日用量费用",
  "cost.total_short": "合计",
  "cost.invoice_details_short": "账单明细",
  "cost.rated_help":
    "Neon 按当期套餐和实际用量计算，Cloudflare 使用官方日费用。未出账金额以最终账单为准。点击日期查看明细。",
  "cost.partial_help":
    "此金额包含已取得的明细；存在缺失金额或累计对账差异，点击日期查看。",
  "cost.calculated": "按用量计算",

  "cost.snapshot_short": "官方已记账 · 人工核验快照",
  "cost.snapshot_note":
    "此金额来自供应商控制台核验，不随用量接口自动刷新；以显示的核验时间为准。它不是整月最终账单，也不分摊成每日金额。",
  "cost.quantity_only": "用量已同步",
  "cost.no_daily_amount": "未提供日金额",
  "cost.amount_mismatch": "日金额与累计不一致",
  "cost.missing_baseline": "缺少对账基准",
  "cost.neon_launch": "Launch",
  "cost.neon_scale": "Scale",
  "cost.help": "查看说明",
  "cost.close_help": "关闭说明",
  "cost.settled_short": "已结算",
  "cost.partial_short": "部分金额",
  "cost.unverified_short": "待核实",
  "cost.service_month_title": "服务期费用总览",
  "cost.service_month_rule":
    "按费用实际所属服务期统计。开票日期不改变归属；上月消费在本月出账，仍归上月。默认展示本月。",
  "cost.no_false_total":
    "固定月价和本月已发生消费分开列示。未结清、金额缺失或跨月未分配时，不生成一个看似完整的月总额，也不把未出账当作零。",
  "cost.fixed_monthly_rate": "固定订阅 / 月",
  "cost.variable_month": "本月按量消费",
  "cost.fixed_unverified": "未取得套餐记录",
  "cost.final_month_invoice":
    "已出账 · 此服务月完整账单已核对；替代用量金额，不重复相加。",
  "cost.partial_month_usage":
    "供应商计量 · 仅已取得且可核对的部分金额；尚非完整月费用。",
  "cost.unknown_records": "金额待核实记录",
  "cost.records": "用量记录总数",
  "cost.fixed_composition": "固定订阅构成 / 月",
  "cost.variable_composition": "用量分类",
  "cost.actual_cycle": "账期",
  "cost.fixed_cycle_rule":
    "账期结束日不包含当日。跨自然月订阅只列一次；月价不是本月已发生金额，不按开票日归入整月，不自行按天摊成实际费用。",
  "cost.service_period": "服务期",
  "cost.related_invoices": "本服务月关联的已出账明细",
  "cost.related_invoice_note":
    "按明细服务期关联，不按开票月份。跨月项目保留原账期金额，未拆成自然月实际金额；账单级税额未擅自分摊，保留在完整原件中；下方账单用于对账，不再次加入总览。",
  "cost.issued": "开票日期",
  "cost.whole_invoice": "整张账单金额（含其他服务期，不代表本月费用）",
  "cost.cross_month": "已出账 · 跨月账期，未按天摊分",
  "cost.in_month": "已出账 · 归属所选服务月",
  "cost.no_service_invoice":
    "尚未取得该服务月的关联账单；仍可查看上方未出账用量。",
  "cost.invoice_original_expand": "展开完整账单原件明细（不参与本月合计）",
  "cost.settled": "服务期已出账",
  "cost.unsettled": "已计量 / 尚未关联账单",
  "cost.unverified": "对账未通过",
  "cost.billing_status": "出账状态",
  "cost.issue_ledger": "开票流水",
};
export const periodEn: Record<keyof typeof periodZh, string> = {
  "cost.fee_short": "Cost",
  "cost.resource_short": "Resource",
  "cost.unit_price_short": "Unit price",
  "cost.billable_short": "Billable usage",
  "cost.reported_short": "Reported daily cost",
  "cost.cumulative_short": "Reported cumulative cost",
  "cost.source_short": "Source",
  "cost.invoice_level_short": "Invoice-level items",

  "cost.full_invoice_toggle": "Show complete invoices",
  "cost.invoice_number": "Invoice",
  "cost.charge_kind": "Type",
  "cost.invoice_item": "Item",
  "cost.no_invoice_short": "No invoices for this month",
  "cost.last_sync": "Last sync",
  "cost.auto_sync_help":
    "Background sync hourly; page refresh every 15 minutes. UTC. Provider posting may lag.",
  "cost.sync_failed_short": "Sync issue",
  "cost.fixed_short": "Fixed costs",
  "cost.plan_short": "Plan",
  "cost.monthly_short": "Monthly fee",
  "cost.daily_short": "Daily usage costs",
  "cost.total_short": "Total",
  "cost.invoice_details_short": "Invoices",
  "cost.rated_help":
    "Neon: actual usage rated by period plan. Cloudflare: reported daily costs. Unbilled costs are subject to final invoicing. Select a date for details.",
  "cost.partial_help":
    "Retrieved amounts only; missing prices or cumulative reconciliation differences. Select the date for details.",
  "cost.calculated": "Usage calculation",

  "cost.snapshot_short": "Provider posted charges · manually verified snapshot",
  "cost.snapshot_note":
    "Verified from the provider console, not automatically refreshed by the consumption API. Refer to its verification time. Not a final monthly invoice or a daily allocation.",
  "cost.quantity_only": "Usage synchronized",
  "cost.no_daily_amount": "Daily amount not provided",
  "cost.amount_mismatch": "Daily/cumulative mismatch",
  "cost.missing_baseline": "Missing reconciliation baseline",
  "cost.neon_launch": "Launch usage plan (no fixed monthly fee)",
  "cost.neon_scale": "Scale usage plan (no fixed monthly fee)",
  "cost.help": "View explanation",
  "cost.close_help": "Close explanation",
  "cost.settled_short": "Settled",
  "cost.partial_short": "Partial amount",
  "cost.unverified_short": "Unverified",
  "cost.service_month_title": "Service-month costs",
  "cost.service_month_rule":
    "Costs belong to their service period, regardless of invoice date. Defaults to this month.",
  "cost.no_false_total":
    "Contract monthly rates and accrued usage are separate. Missing or unallocated amounts prevent a complete monthly total; unbilled does not mean zero.",
  "cost.fixed_monthly_rate": "Fixed subscriptions · monthly contract rate",
  "cost.variable_month": "Usage · selected service month",
  "cost.fixed_unverified": "No verified fixed subscription record; not zero.",
  "cost.final_month_invoice":
    "Invoiced · reconciled full service month; replaces usage amounts, never adds to them.",
  "cost.partial_month_usage":
    "Provider metering · reconciled retrieved amounts only; not a complete monthly cost.",
  "cost.unknown_records": "Records with unverified amounts",
  "cost.records": "Usage records",
  "cost.fixed_composition":
    "Fixed subscription rates (not this month's payments)",
  "cost.variable_composition": "Retrieved usage costs for this service month",
  "cost.actual_cycle": "Subscription period (exclusive end)",
  "cost.fixed_cycle_rule":
    "Cross-month subscriptions appear once. Monthly rates are not accrued amounts, assigned by invoice date, or silently prorated.",
  "cost.service_period": "Service period (exclusive end)",
  "cost.related_invoices": "Invoiced items related to this service month",
  "cost.related_invoice_note":
    "Matched by item service period, not invoice month. Cross-month item amounts remain unallocated; invoices reconcile costs rather than add to them.",
  "cost.issued": "Issued",
  "cost.whole_invoice":
    "Whole invoice (includes other service periods, not this month's cost)",
  "cost.cross_month": "Cross-month item · monthly allocation unverified",
  "cost.in_month": "Belongs to selected service month",
  "cost.no_service_invoice":
    "No related invoice retrieved; unbilled usage remains above.",
  "cost.invoice_original_expand":
    "Full original invoice items (not added to this month)",
  "cost.settled": "Service period invoiced",
  "cost.unsettled": "Metered / no associated invoice",
  "cost.unverified": "Amount unverified",
  "cost.billing_status": "Invoice status",
  "cost.issue_ledger":
    "Separate invoice-date ledger (excluded from service-month totals)",
};
